import AttachLibraryDialog from 'components/@home/@settings/Tabs/Agents/AttachLibraryDialog';
import FileTreeOutlineIcon from 'mdi-react/FileTreeOutlineIcon';
import { arrayOf, bool, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const AttachSkillsDialog = ({
  open,
  onClose,
  skills,
  selectedIds = [],
  onSave,
  onCreateSkill = null,
}) => (
  <AttachLibraryDialog
    open={open}
    onClose={onClose}
    title={I18n.t('AgenticChatFlow.AttachSkillsTitle')}
    items={skills}
    selectedIds={selectedIds}
    onSave={onSave}
    onCreate={onCreateSkill}
    createLabel={I18n.t('AgenticChatFlow.CreateSkill')}
    searchPlaceholder={I18n.t('AgenticChatFlow.SearchSkills')}
    emptyLabel={I18n.t('AgenticChatFlow.NoSkillsLibrary')}
    noMatchesLabel={I18n.t('AgenticChatFlow.NoToolsMatchSearch')}
    renderIcon={() => <FileTreeOutlineIcon size={18} />}
    renderMeta={skill => skill.description || null}
  />
);

AttachSkillsDialog.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  skills: arrayOf(object).isRequired,
  selectedIds: arrayOf(object),
  onSave: func.isRequired,
  onCreateSkill: func,
};

export default AttachSkillsDialog;
